const availableLanguage = [
  'en',
  'fr',
];

export default availableLanguage;
